const TCPPointsConfig = [{ span: 8, height: "176px", classes: "marginTop-32" }]

export default TCPPointsConfig
